export default __webpack_public_path__ + "static/media/Aksakov_Anatoly_Gennadievich.66b7a594.webp";